import script from "./ManutOsExecucaoPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ManutOsExecucaoPage.vue?vue&type=script&setup=true&lang=js"

import "./ManutOsExecucaoPage.vue?vue&type=style&index=0&id=131ac2b4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-131ac2b4"]])

export default __exports__